var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.41 233.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}.cls-2{fill:#b4ccc7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.15,21l4.26,4.96V207.23l-4.25,4.95H25.37l-4.37-5.08V25.96l4.26-4.96h230.89m3.67-8H21.59l-8.59,9.99V210.06l8.69,10.11h238.14l8.58-9.98V22.99l-8.59-9.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.83,13l8.59,9.99V210.2l-8.58,9.98H21.69l-8.69-10.11V22.99l8.59-9.99h238.24m5.97-13H15.62l-3.89,4.53L3.14,14.52l-3.14,3.65V214.88l3.14,3.65,8.69,10.11,3.89,4.53h250.08l3.89-4.53,8.58-9.98,3.14-3.65V18.17l-3.14-3.65-8.59-9.99-3.89-4.53h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeBorder);
export default __webpack_public_path__ + "static/media/gauge-border.d0a5b66d339fb1aa6b6a633f1438e320.svg";
export { ForwardRef as ReactComponent };